// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

body {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: orangered;
}

::selection {
  color: #fff;
  background: #3c87ff;
}

.wrapper {
  height: 100%;
  max-width: 1366px;
  padding-top: 50px;
  margin: 0px auto;
  background: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.task-input {
  height: 52px;
  padding: 0 50px;
  position: relative;
}

.task-input input {
  height: 100%;
  width: 100%;
  outline: none;
  font-size: 18px;
  border-radius: 5px;
  padding: 0 20px 0 10px;
  border: 1px solid #bfbfbf;
}

.task-input input:focus,
.task-input input.active {
  border: 1px solid orangered;
}

.task-input input::placeholder {
  color: #bfbfbf;
}

.controls,
li {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.controls {
  margin: 18px 50px;
  padding: 10px 0px;
  border-bottom: 1px solid orangered;
}

.filters span {
  margin: 0 8px;
  font-size: 17px;
  color: #444444;
  cursor: pointer;
}

.filters span:first-child {
  margin-left: 0;
}

.filters span.active {
  color: orangered;
}

.controls .clear-btn {
  border: none;
  opacity: 0.6;
  outline: none;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  padding: 7px 13px;
  border-radius: 4px;
  letter-spacing: 0.3px;
  transition: transform 0.25s ease;
  background-color: orangered;
}

.clear-btn.active {
  opacity: 0.9;
}

.clear-btn:active {
  transform: scale(0.93);
}

.clear-btn:hover {
  cursor: pointer;
}

.task-box {
  margin-top: 20px;
  margin-right: 5px;
  padding: 0 50px 10px 50px;
}

.task-box.overflow {
  overflow-y: auto;
  max-height: 300px;
}

.task-box::-webkit-scrollbar {
  width: 5px;
}

.task-box::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 25px;
}

.task-box::-webkit-scrollbar-thumb {
  background: #e6e6e6;
  border-radius: 25px;
}

.task-box .task {
  list-style: none;
  font-size: 17px;
  margin-bottom: 18px;
  padding-bottom: 16px;
  align-items: flex-start;
  border-bottom: 1px solid #ccc;
}

.task-box .task:last-child {
  margin-bottom: 0;
  border-bottom: 0;
  padding-bottom: 0;
}

.task-box .task label {
  display: flex;
  align-items: flex-start;
}

.task label input {
  margin-top: 7px;
  accent-color: orangered;
}

.task label p {
  user-select: none;
  margin-left: 12px;
  word-wrap: break-word;
}

.task label p.checked {
  text-decoration: line-through;
}

.task-box .settings {
  position: relative;
}

.settings :where(i, li) {
  cursor: pointer;
}

.settings .task-menu {
  z-index: 10;
  right: -5px;
  bottom: -65px;
  padding: 5px 0;
  background: #fff;
  position: absolute;
  border-radius: 4px;
  transform: scale(0);
  transform-origin: top right;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease;
}

.task-box .task:last-child .task-menu {
  bottom: 0;
  transform-origin: bottom right;
}

.task-box .task:first-child .task-menu {
  bottom: -65px;
  transform-origin: top right;
}

.task-menu.show {
  transform: scale(1);
}

.task-menu li {
  height: 25px;
  font-size: 16px;
  margin-bottom: 2px;
  padding: 17px 15px;
  cursor: pointer;
  justify-content: flex-start;
}

.task-menu li:last-child {
  margin-bottom: 0;
}

.settings li:hover {
  background: #f5f5f5;
}

.settings li i {
  padding-right: 8px;
}

@media (max-width: 400px) {
  .wrapper {
    padding: 20px 0;
  }
  .task-input input {
    padding: 0px 10px 0px 8px;
  }
  .controls {
    margin: 5px 20px;
  }
  .controls .filters {
    display: flex;
    flex-direction: column;
    padding: 0px;
  }
  .filters span {
    margin: 0px;
  }
  .task-input {
    padding: 0 20px;
  }
  .task-box {
    padding: 0px 20px;
  }
  .task label input {
    margin-top: 4px;
  }
}
@media (min-width: 1367px) {
  .wrapper {
    margin: 50px auto;
    border-radius: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./style/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;AACF;;AACA;EACE,WAAA;EACA,mBAAA;AAEF;;AAAA;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;AAGF;;AADA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AAIF;;AADA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAIF;;AADA;;EAEE,2BAAA;AAIF;;AAFA;EACE,cAAA;AAKF;;AAHA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;AAMF;;AAJA;EACE,iBAAA;EACA,iBAAA;EACA,kCAAA;AAOF;;AALA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAQF;;AANA;EACE,cAAA;AASF;;AAPA;EACE,gBAAA;AAUF;;AARA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;EACA,2BAAA;AAWF;;AATA;EACE,YAAA;AAYF;;AAVA;EACE,sBAAA;AAaF;;AAXA;EACE,eAAA;AAcF;;AAXA;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;AAcF;;AAZA;EACE,gBAAA;EACA,iBAAA;AAeF;;AAbA;EACE,UAAA;AAgBF;;AAdA;EACE,mBAAA;EACA,mBAAA;AAiBF;;AAfA;EACE,mBAAA;EACA,mBAAA;AAkBF;;AAhBA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,6BAAA;AAmBF;;AAjBA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;AAoBF;;AAlBA;EACE,aAAA;EACA,uBAAA;AAqBF;;AAnBA;EACE,eAAA;EACA,uBAAA;AAsBF;;AApBA;EACE,iBAAA;EACA,iBAAA;EACA,qBAAA;AAuBF;;AArBA;EACE,6BAAA;AAwBF;;AAtBA;EACE,kBAAA;AAyBF;;AAvBA;EACE,eAAA;AA0BF;;AAxBA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uCAAA;EACA,+BAAA;AA2BF;;AAzBA;EACE,SAAA;EACA,8BAAA;AA4BF;;AA1BA;EACE,aAAA;EACA,2BAAA;AA6BF;;AA3BA;EACE,mBAAA;AA8BF;;AA5BA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AA+BF;;AA7BA;EACE,gBAAA;AAgCF;;AA9BA;EACE,mBAAA;AAiCF;;AA/BA;EACE,kBAAA;AAkCF;;AA/BA;EAEE;IACE,eAAA;EAiCF;EA9BF;IACI,yBAAA;EAgCF;EA9BF;IACE,gBAAA;EAgCA;EA7BF;IACI,aAAA;IACA,sBAAA;IACA,YAAA;EA+BF;EA5BA;IACE,WAAA;EA8BF;EA5BA;IACE,eAAA;EA8BF;EA3BA;IACE,iBAAA;EA6BF;EA3BA;IACE,eAAA;EA6BF;AACF;AAzBA;EACE;IACE,iBAAA;IACA,mBAAA;EA2BF;AACF","sourcesContent":["* {\n  padding: 0px;\n  margin: 0px;\n  box-sizing: border-box;\n  font-family: \"Poppins\", sans-serif;\n}\n\nbody {\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  background-color: orangered;\n}\n::selection {\n  color: #fff;\n  background: #3c87ff;\n}\n.wrapper {\n  height: 100%;\n  max-width: 1366px;\n  padding-top: 50px;\n  margin: 0px auto;\n  background: #fff;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n.task-input {\n  height: 52px;\n  padding: 0 50px;\n  position: relative;\n}\n\n.task-input input {\n  height: 100%;\n  width: 100%;\n  outline: none;\n  font-size: 18px;\n  border-radius: 5px;\n  padding: 0 20px 0 10px;\n  border: 1px solid #bfbfbf;\n}\n\n.task-input input:focus,\n.task-input input.active {\n  border: 1px solid orangered;\n}\n.task-input input::placeholder {\n  color: #bfbfbf;\n}\n.controls,\nli {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.controls {\n  margin: 18px 50px;\n  padding: 10px 0px;\n  border-bottom: 1px solid orangered;\n}\n.filters span {\n  margin: 0 8px;\n  font-size: 17px;\n  color: #444444;\n  cursor: pointer;\n}\n.filters span:first-child {\n  margin-left: 0;\n}\n.filters span.active {\n  color: orangered;\n}\n.controls .clear-btn {\n  border: none;\n  opacity: 0.6;\n  outline: none;\n  color: #fff;\n  cursor: pointer;\n  font-size: 13px;\n  padding: 7px 13px;\n  border-radius: 4px;\n  letter-spacing: 0.3px;\n  transition: transform 0.25s ease;\n  background-color: orangered;\n}\n.clear-btn.active {\n  opacity: 0.9;\n}\n.clear-btn:active {\n  transform: scale(0.93);\n}\n.clear-btn:hover {\n  cursor: pointer;\n}\n\n.task-box {\n  margin-top: 20px;\n  margin-right: 5px;\n  padding: 0 50px 10px 50px;\n}\n.task-box.overflow {\n  overflow-y: auto;\n  max-height: 300px;\n}\n.task-box::-webkit-scrollbar {\n  width: 5px;\n}\n.task-box::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 25px;\n}\n.task-box::-webkit-scrollbar-thumb {\n  background: #e6e6e6;\n  border-radius: 25px;\n}\n.task-box .task {\n  list-style: none;\n  font-size: 17px;\n  margin-bottom: 18px;\n  padding-bottom: 16px;\n  align-items: flex-start;\n  border-bottom: 1px solid #ccc;\n}\n.task-box .task:last-child {\n  margin-bottom: 0;\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n.task-box .task label {\n  display: flex;\n  align-items: flex-start;\n}\n.task label input {\n  margin-top: 7px;\n  accent-color: orangered;\n}\n.task label p {\n  user-select: none;\n  margin-left: 12px;\n  word-wrap: break-word;\n}\n.task label p.checked {\n  text-decoration: line-through;\n}\n.task-box .settings {\n  position: relative;\n}\n.settings :where(i, li) {\n  cursor: pointer;\n}\n.settings .task-menu {\n  z-index: 10;\n  right: -5px;\n  bottom: -65px;\n  padding: 5px 0;\n  background: #fff;\n  position: absolute;\n  border-radius: 4px;\n  transform: scale(0);\n  transform-origin: top right;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);\n  transition: transform 0.2s ease;\n}\n.task-box .task:last-child .task-menu {\n  bottom: 0;\n  transform-origin: bottom right;\n}\n.task-box .task:first-child .task-menu {\n  bottom: -65px;\n  transform-origin: top right;\n}\n.task-menu.show {\n  transform: scale(1);\n}\n.task-menu li {\n  height: 25px;\n  font-size: 16px;\n  margin-bottom: 2px;\n  padding: 17px 15px;\n  cursor: pointer;\n  justify-content: flex-start;\n}\n.task-menu li:last-child {\n  margin-bottom: 0;\n}\n.settings li:hover {\n  background: #f5f5f5;\n}\n.settings li i {\n  padding-right: 8px;\n}\n\n@media (max-width: 400px) {\n  \n  .wrapper {\n    padding: 20px 0;\n  }\n  \n.task-input input{\n    padding: 0px 10px 0px 8px;\n}\n.controls{\n  margin: 5px 20px;\n}\n\n.controls .filters{\n    display: flex;\n    flex-direction: column;\n    padding: 0px;\n}\n\n  .filters span {\n    margin: 0px;\n  }\n  .task-input {\n    padding: 0 20px;\n  }\n\n  .task-box {\n    padding: 0px 20px;\n  }\n  .task label input {\n    margin-top: 4px;\n  }\n}\n\n\n@media (min-width: 1367px){\n  .wrapper{\n    margin: 50px auto;\n    border-radius: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
